import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

interface QuestionFilter {
  tag: string;
  type: string;
}

export function useIsWorkplaceReviewUXUpdateEnabled(): {
  isEnabled: boolean;
  questionFiltersToBeShownWhenEnabled: QuestionFilter[];
  questionFiltersToBeHiddenWhenDisabled: QuestionFilter[];
} {
  const flag = useCbhFlag(CbhFeatureFlag.WORKPLACE_REVIEW_UX_UPDATE, {
    defaultValue: {
      enabled: false,
      questionFiltersToBeShownWhenEnabled: [
        { tag: "PATIENTS_PER_NURSE", type: "NUMBER" },
        { tag: "SUPPLY_RATING", type: "RATING" },
        { tag: "CLEANLINESS", type: "RATING" },
        { tag: "CULTURE", type: "RATING" },
        { tag: "PATIENT_CARE", type: "RATING" },
      ],
      questionFiltersToBeHiddenWhenDisabled: [
        { tag: "SUPPLY_RATING", type: "RATING" },
        { tag: "CLEANLINESS", type: "RATING" },
        { tag: "CULTURE", type: "RATING" },
        { tag: "PATIENT_CARE", type: "RATING" },
      ],
    },
  });

  return {
    isEnabled: flag.enabled,
    questionFiltersToBeShownWhenEnabled: flag.questionFiltersToBeShownWhenEnabled,
    questionFiltersToBeHiddenWhenDisabled: flag.questionFiltersToBeHiddenWhenDisabled,
  };
}
